import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

type CreateOfferActionsProps = {
  handleSubmit: () => void;
  isEditMode: boolean;
  disabled?: boolean;
};

const CreateOfferActions: React.FC<CreateOfferActionsProps> = ({
  handleSubmit,
  isEditMode,
  disabled = false
}) => {
  const { t } = useTranslation(['events']);
  
  return (
    <>
      <div className="w-full bg-white fixed bottom-0 left-0 p-4 z-10 border-t pb-12 md:pb-4">
        <div className="w-full md:w-[343px] mx-auto">
          <div className="flex gap-4">
            <Button
              type={ButtonType.Primary}
              onClick={handleSubmit}
              disabled={disabled}
            >
              <div className="flex items-center justify-center">
                {isEditMode ? t('settings.promoterOffers.createOffer.updateOffer') : t('settings.promoterOffers.createOffer.createOffer')}
              </div>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateOfferActions;
